import { Box, Switch, Typography } from "@mui/material";
import React, { useEffect } from "react";

import { LocationAddOnSettings } from "./index";
import WorkerMovementSettings from "./worker-movement-settings";

interface AdvancedSchedulingLocationProps {
    currentSettings: LocationAddOnSettings;
    setCurrentSettings: React.Dispatch<React.SetStateAction<LocationAddOnSettings | null>>;
    isCompanyAdvancedSchedulingEnabled: boolean;
    locationId: number;
}

const AdvancedSchedulingLocation: React.FC<AdvancedSchedulingLocationProps> = ({
    currentSettings,
    setCurrentSettings,
    isCompanyAdvancedSchedulingEnabled,
    locationId,
}) => {

        useEffect(() => {
        if (!isCompanyAdvancedSchedulingEnabled) {
            setCurrentSettings(prev => {
                if (!prev) return null;
                return { ...prev, isEnabled: false };
            });
        }
    }, [isCompanyAdvancedSchedulingEnabled, setCurrentSettings]);

    const handleSettingChange = (field: keyof LocationAddOnSettings, value: any) => {
        setCurrentSettings(prevSettings => {
            if (!prevSettings) return null;
            return {
                ...prevSettings,
                [field]: value,
            };
        });
    };

    return (
        <Box sx={{ backgroundColor: "#F5F5F5", borderRadius: "8px", padding: "16px", mt: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box>
                    <Typography sx={{ fontSize: "16px", color: "rgba(0, 0, 0, 0.87)" }}>
                        Advanced Scheduling
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.6)" }}>
                        Efficiently allocate available Workers across Jobs and Departments on regular Shifts
                    </Typography>
                </Box>
                <Box
    sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }}
>
                <Switch
                    checked={currentSettings.isEnabled}
                    onChange={(e) => handleSettingChange("isEnabled", e.target.checked)}
                    disabled={!isCompanyAdvancedSchedulingEnabled}
                />
                </Box>
            </Box>

            {currentSettings.isEnabled && (
                <Box sx={{ pl: 2, pt: 2, mt: 2, borderTop: "1px solid rgba(0,0,0,0.12)"}}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                        <Typography sx={{ fontSize: "14px" }}>
                            Allow Workers to setup Preferences for allocation
                        </Typography>
                        <Switch checked={currentSettings.allowWorkerPreferences} onChange={(e) => handleSettingChange("allowWorkerPreferences", e.target.checked)} />
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: "14px" }}>
                            Allow Schedule generation to automatically optimize allocation
                        </Typography>
                        <Switch checked={currentSettings.autoOptimize} onChange={(e) => handleSettingChange("autoOptimize", e.target.checked)} />
                    </Box>
                    {currentSettings.autoOptimize && (
                        <WorkerMovementSettings locationId={locationId} />
                    )}
                </Box>
            )}
        </Box>
    );
};

export default AdvancedSchedulingLocation;